import { useMemo } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { LOGIN_HINT_PARAM } from '../constants/TargetFlows';
const queryDataValues = ['useDark', 'loginRedirectUrl', 'allowFbSignup', 'hideSignupLink', 'signupParams', 'pageId', 'loginPortalId'];
const queryDataBooleans = ['useDark', 'allowFbSignup'];

// A list of known nested redirect query parameters that could appear inside of
// loginRedirectUrl which need double encoding
const nestedRedirectParams = ['redirect'];
export const useQueryData = () => {
  const {
    search
  } = useLocation();
  return useMemo(() => {
    const query = new URLSearchParams(search);

    // login_hint is an alias for email used by external OAuth initiators (e.g.
    // the OpenAI connector). Normalize it so the rest of the app only deals
    // with `email`.
    if (!query.get('email') && query.get(LOGIN_HINT_PARAM)) {
      query.set('email', query.get(LOGIN_HINT_PARAM));
    }
    const queryData = Object.fromEntries(queryDataValues.map(value => {
      if (value === 'loginRedirectUrl') {
        const loginRedirectUrl = query.get(value);
        if (loginRedirectUrl) {
          const hasNestedRedirect = nestedRedirectParams.some(param => loginRedirectUrl.includes(`${param}=`));
          if (hasNestedRedirect) {
            try {
              const url = new URL(loginRedirectUrl);
              const nestedParamsToEncode = {};
              nestedRedirectParams.forEach(param => {
                const paramValue = url.searchParams.get(param);
                if (paramValue) {
                  nestedParamsToEncode[param] = paramValue;
                  url.searchParams.delete(param);
                }
              });
              let urlStr = url.toString();
              const separator = url.search ? '&' : '?';
              const encodedParams = Object.entries(nestedParamsToEncode).map(([key, val]) => `${key}=${encodeURIComponent(encodeURIComponent(val))}`).join('&');
              if (encodedParams) {
                urlStr = `${urlStr}${separator}${encodedParams}`;
              }
              return [value, urlStr];
            } catch (e) {
              return [value, loginRedirectUrl];
            }
          }
        }
        return [value, loginRedirectUrl];
      }
      if (value === 'loginPortalId') {
        return [value, !query.get(value) || isNaN(Number(query.get(value))) || Number(query.get(value)) <= 0 ? undefined : Number(query.get(value))];
      }
      if (queryDataBooleans.includes(value)) {
        return [value, query.get(value) === 'true'];
      }
      return [value, query.get(value) ? query.get(value) : undefined];
    }));
    return {
      allQueryParams: Object.fromEntries([...query]),
      queryData
    };
  }, [search]);
};